import _BaseAPIService from "./_BaseAPIService";

const slug = "cooperatives";
const api_Service = _BaseAPIService.instance;
const user = JSON.parse(localStorage.getItem("user"));
const coopId = user?.user?.cooperative_id;

const CooperativeService = {
  get: async () => {
    const response = await api_Service.get(`/${slug}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api_Service.post(`/${slug}`, data);
    return response.data;
  },

  getById: async (coopId) => {
    const response = await api_Service.get(`/${slug}/${coopId}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api_Service.delete(`/${slug}/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api_Service.put(`/${slug}/${id}`, data);
    return response.data;
  },
};

export default CooperativeService;
